import React, { useMemo } from 'react';
import LazyLoad from 'react-lazyload';
import { number } from 'prop-types';
import useLanguageCode from 'hooks/useLanguageCode';
import { checkLinkAndAppendLanguage } from 'utils/localization';
import { StringConstantsMixin } from 'react_components/mixins/shared/string_constants_mixin';
import { DESKTOP_BREAKPOINT } from 'utils/constants/breakpoints';
import { FormattedMessage } from 'react-intl';
import useUser from 'hooks/useUser';
import useFeatureFlags from 'hooks/useFeatureFlags';
import { logHomepageProUpsellBlockButtonClicked } from '@alltrails/analytics/amplitudeFunctions';
import FeatureRow from './FeatureRow';
import * as styles from './styles/styles.module.scss';
import logoPro from './logo_pro.png';
import proHeader from './pro_header.png';

const BG_IMAGE_BASE = 'https://cdn-assets.alltrails.com/assets/images/homepage/pro_upsell/';

const {
  strings: {
    COUPON: { FREE },
    HOME_PAGE: {
      PRO_UPSELL: { STAY_ON_TRACK, FEATURES, FEATURE_FAVORITE, FEATURE_LOG, REAL_TIME_OVERLAYS, FEATURE_OFFLINE, FEATURE_PRINT, FEATURE_OFF_ROUTE }
    }
  }
} = StringConstantsMixin;

const ProUpsell = ({ windowWidth }) => {
  const languageCode = useLanguageCode();
  const user = useUser();
  const featureFlags = useFeatureFlags();

  const featuresContainerStyle = useMemo(() => {
    const isDesktop = windowWidth && windowWidth >= DESKTOP_BREAKPOINT;

    if (!isDesktop) {
      return {};
    }

    const fileName = `bg_desktop_${languageCode}.jpg`;
    const backgroundImageUrl = `${BG_IMAGE_BASE}${fileName}`;

    return {
      backgroundImage: `url(${backgroundImageUrl})`
    };
  }, [windowWidth]);

  const upperContainerStyle = {
    backgroundImage: `url(${BG_IMAGE_BASE}bg_mobile_${languageCode}.jpg)`
  };

  return (
    <div className={styles.container}>
      <div style={upperContainerStyle} className={styles.upperContainer} />
      <div style={featuresContainerStyle} className={styles.featuresContainer}>
        <LazyLoad>
          <img className={styles.logoProImage} src={logoPro} alt="" />
        </LazyLoad>
        <h2 className={styles.title}>{STAY_ON_TRACK}</h2>
        <div className={styles.headerRow}>
          <div className={[styles.tableHeader, styles.headerRowFeature].join(' ')}>{FEATURES}</div>
          <div className={[styles.tableHeader, styles.headerRowFreePro].join(' ')}>{FREE}</div>
          <div className={styles.headerRowFreePro}>
            <LazyLoad>
              <img src={proHeader} className={styles.headerRowProIcon} alt="" />
            </LazyLoad>
          </div>
        </div>
        <FeatureRow free tint text={FEATURE_FAVORITE} />
        <FeatureRow free tint={false} text={FEATURE_LOG} />
        <FeatureRow free={false} tint text={FEATURE_OFFLINE} />
        <FeatureRow free={false} tint={false} text={REAL_TIME_OVERLAYS} />
        <FeatureRow free={false} tint text={FEATURE_PRINT} />
        <FeatureRow free={false} tint={false} text={FEATURE_OFF_ROUTE} />
        <a
          href={checkLinkAndAppendLanguage('/pro?ref=homepage_pro_proupsell')}
          className={styles.buyLink}
          onClick={logHomepageProUpsellBlockButtonClicked}
        >
          {(!user || user.isPromoEligible) && featureFlags.sevenDayTrial ? (
            <FormattedMessage defaultMessage="Try Pro for Free" />
          ) : (
            <FormattedMessage defaultMessage="Buy Pro" />
          )}
        </a>
      </div>
    </div>
  );
};

ProUpsell.propTypes = {
  windowWidth: number
};

ProUpsell.defaultProps = {
  windowWidth: null
};

export default ProUpsell;
